class NavBlog extends HTMLElement {
    constructor() {
      super();
      this.changeTabHighlight();  
    }

    changeTabHighlight() {
        document.addEventListener('DOMContentLoaded', () => {
            let pageName =  this.baseURI;
            let tabs = this.children[0].children;
            let tabsArray = Array.from(tabs);
            let currentPageTab = null;
            tabsArray.forEach(tab => {
                let tabUrl = tab.children[1].href;
                if (pageName.includes(tabUrl)) {
                    tab.classList.add('current-page');
                    currentPageTab = tab;
                }
            });

            if (currentPageTab && window.innerWidth < 768) {
                this.centerCurrentPageTab(currentPageTab);
            }
        });
    }

    centerCurrentPageTab(tab) {
        const parent = tab.parentElement;
        const parentRect = parent.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const parentScrollLeft = parent.scrollLeft;
        const offsetLeft = tabRect.left - parentRect.left;
        const offsetCenter = offsetLeft - (parentRect.width / 2) + (tabRect.width / 2);
        
        parent.scrollLeft = parentScrollLeft + offsetCenter;
    }
}

customElements.define('nav-blog', NavBlog);